<template>
  <div>
    <b-card>
      <b-card-header class="px-3 text-primary">
        <i :class="icon" class="mr-1"></i>
        {{ title }}
      </b-card-header>
      <b-card-body class="p-0">
        <div class="datatable availtable">
          <b-card class="mt-4">
            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="S/L" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="slac"
                      placeholder="SLAC"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!slac"
                        @click="slac = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="passenger"
                      placeholder="Passenger"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!passenger"
                        @click="passenger = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <div class="mx-2">
            <b-table
              :dark="$store.state.darkMode"
              ref="btable"
              striped
              hover
              small
              responsive="sm"
              caption-bottom
              stacked="md"
              show-empty
              selectable
              select-mode="multi"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="busy"
              :items="items"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner
                    variant="primary"
                    class="align-middle mr-2"
                  ></b-spinner>
                  <strong class="text-primary">Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(name)="row">
                <a target="_blank" :href="row.item.url">{{ row.item.name }}</a>
              </template>
              <template v-slot:cell(DepartureAirportName)="row"
                >{{ row.item.DepartureAirportName }} (
                {{ row.item.DepartureAirportCode }} )</template
              >
              <template v-slot:cell(Departing)="row"
                >{{ row.item.DepartureDate }}
                {{ row.item.DepartureTime }}</template
              >
              <template v-slot:cell(ArrivalAirportName)="row"
                >{{ row.item.ArrivalAirportName }} (
                {{ row.item.ArrivalAirportCode }} )</template
              >
              <template v-slot:cell(ArrivalDate)="row"
                >{{ row.item.ArrivalDate }} {{ row.item.ArrivalTime }}</template
              >
              <template v-slot:cell(icon)="row">
                <!-- <b-button variant="primary" size="sm"> -->
                <i :class="icon" class="text-primary"></i>
                <!-- </b-button> -->
              </template>
              <template v-slot:cell()="row">
                <div v-if="badges.find((obj) => obj.key == row.field.key)">
                  <span
                    v-html="
                      badgeField(
                        row.item,
                        badges.find((obj) => obj.key == row.field.key)
                      )
                    "
                  ></span>
                </div>
                <div v-else>{{ row.value }}</div>
              </template>
              <template v-if="actions" v-slot:cell(actions)="row">
                <b-button
                  variant="link"
                  :class="action.class + ' py-0'"
                  size="sm"
                  v-for="action in validActions(row.item)"
                  :key="action.key"
                  @click.stop="actionClicked(action.key, row)"
                  :title="action.label"
                  :disabled="checkedItems.length > 0"
                >
                  <i :class="action.icon"></i>
                </b-button>
              </template>
              <!-- :instanceid="$helpers.instanceid()" -->
              <template v-slot:row-details="row">
                <component
                  v-if="actionActive"
                  :is="action.component ? action.component : 'Confirm'"
                  :endpoint="endpoint"
                  :fieldtypes="fieldtypes"
                  :selected="selected"
                  :icon="action.icon"
                  :title="action.title"
                  @discard="discard(row)"
                />
              </template>
            </b-table>
          </div>
          <!--     <b-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">Showing {{ rows }} rows</p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="currentPage"
              :per-page="perPage"
              :total="rows"
            ></pagination>
          </b-card-actions>-->
        </div>
      </b-card-body>
    </b-card>
    <!-- <Ticketviewer/> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import Ticketviewer from "@/pages/components/Ticketviewer";

export default {
  name: "Mobile_Flights",
  components: {
    Ticketviewer,
  },
  props: ["refresh"],
  data() {
    return {
      busy: false,
      title: "Flights",
      icon: "fa fa-plane text-primary",
      endpoint: "mobile_flights",
      features: ["refresh", "find"],
      perPage: 20,
      currentPage: 1,
      rows: 0,
      passenger: null,
      find: null,
      slac: "",
      passenger: "",
      action: { action: "" },
      actionActive: false,
      actions: [
        {
          key: "ticket",
          label: "ticket",
          icon: "fa fa-search-plus",
          single: true,
          multiple: false,
          action: {
            display: "inline",
            component: "Ticketviewer",
          },
        },
      ],
      fields: [
        {
          key: "icon",
          label: "",
          class: "text-right-md hidden-sm",
        },
        // class: "text-right-md",
        {
          key: "PaxName",
          label: "Passenger",
          sortable: true,
          class: "w-md-190px",
        },
        {
          key: "TicketNo",
          label: "Ticket#",
          sortable: true,
        },
        {
          key: "SectorNo",
          label: "Sector#",
          sortable: true,
        },
        {
          key: "Departing",
          label: "Departing",
          sortable: true,
        },
        {
          key: "DepartureAirportName",
          label: "Departure",
          sortable: true,
        },
        {
          key: "ArrivalAirportName",
          label: "Arrival",
          sortable: true,
        },
        {
          key: "Airline",
          label: "Airline",
          sortable: true,
        },
        {
          key: "Issued",
          label: "Issued",
          sortable: true,
          // formatter: (value, key, item) => {
          //   return this.$moment(value,'DD/MM/YYYY HH:MM:SS').format("DD/MM/YYYY HH:MM")
          // }
        },
        {
          key: "actions",
          label: "Actions",
          class: "actions w-55px",
        },
      ],
      fieldtypes: [],
      badges: [],
      items: [],
      checkedItems: [],
      filter: [],
      component: {},
    };
  },
  mounted() {
    this.fields.splice(0, 0, {
      key: "features",
      label: "",
      class: "features text-center pl-0 pr-0 w-20px",
    });
    let name =
      this.user.lastname + "/" + this.user.firstname + " " + this.user.title;
    this.passenger = name.toUpperCase();
    this.slac = this.user.slac;
    this.loadData();

    var thElm;
    var startOffset;

    Array.prototype.forEach.call(
      document.querySelectorAll("table th"),
      function (th) {
        th.style.position = "relative";

        var grip = document.createElement("div");
        grip.innerHTML = "&nbsp;";
        grip.style.top = 0;
        grip.style.right = 0;
        grip.style.bottom = 0;
        grip.style.width = "5px";
        grip.style.position = "absolute";
        grip.style.cursor = "col-resize";
        grip.addEventListener("mousedown", function (e) {
          thElm = th;
          startOffset = th.offsetWidth - e.pageX;
        });

        th.appendChild(grip);
      }
    );

    document.addEventListener("mousemove", function (e) {
      if (thElm) {
        thElm.style.width = startOffset + e.pageX + "px";
      }
    });

    document.addEventListener("mouseup", function () {
      thElm = undefined;
    });
  },
  watch: {
    refresh: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log("refresh now");
        this.loadData();
      },
    },
    find: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          // HOW TO GET THE FILTERED ITEMS
          if (this.$refs.btable) {
            this.$nextTick(() => {
              this.rows = this.$refs.btable.$refs.itemRows.length;
            });
          }
        } else {
          // ALL DATA
          this.rows = this.items.length;
        }
      },
    },
    slac: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log("find slac", newVal);
        //if (newVal) {
        this.loadData();
        //}
      },
    },
    passenger: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log("find passenger", newVal);
        //if (newVal) {
        this.loadData();
        //}
      },
    },
  },
  computed: {
    ...mapGetters(["user"]),

    disable_slac() {
      if (this.user.rolename == "admin") {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    disable_passenger() {
      let mobile_admin = true;
      if (mobile_admin) {
        return false;
      }
      if (this.user.rolename == "admin") {
        return false;
      }
      return true;
    },
    async loadData() {
      this.busy = true;
      let variables = {
        slac: this.slac,
        pax: this.passenger,
      };
      console.log("variables: ", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query mobile_flights($slac: String, $pax: String, $paxid: Int) {
              mobile_flights(slac: $slac, pax: $pax, paxid: $paxid) {
                id
                result {
                  ClientCode
                  ClientCoName
                  PaxItem
                  Reference
                  Issued
                  Consultant
                  EventCode
                  EventName
                  PaxID
                  PaxName
                  TicketNo
                  VendorLocator
                  SectorNo
                  Ticketed
                  SectorType
                  Airline
                  FlightNo
                  DepartureDate
                  DepartureTime
                  DepartureAirportCode
                  DepartureAirportCountry
                  DepartureAirportName
                  DepartureTerminal
                  ArrivalDate
                  ArrivalTime
                  ArrivalAirportCode
                  ArrivalAirportCountry
                  ArrivalAirportName
                  ArrivalTerminal
                  Class
                  ClassDescription
                  Craft
                  NumberOfStops
                  Distance
                  GMTDeparture
                  GMTArrival
                  FareBasis
                  Bags
                  FlightDuration
                  Status
                  AgencyIATA
                  FormOfPayment
                  FareCalculation
                  Endorsements
                }
              }
            }
          `,
          variables,
        });
        console.log("query result", response.data.mobile_flights);
        this.items = [];
        for (var i = 0; i < response.data.mobile_flights.result.length; i++) {
          let item = response.data.mobile_flights.result[i];
          if (this.passenger != "") {
            if (item.PaxName == this.passenger) {
              this.items.push(response.data.mobile_flights.result[i]);
            }
          } else {
            this.items.push(response.data.mobile_flights.result[i]);
          }
        }

        this.rows = this.items.length;
      } catch (error) {}
      this.busy = false;
      await this.$emit("refreshed");
    },
    feature(option) {
      if (this.features) {
        return this.features.includes(option);
      }
      return false;
    },
    rowClass(item, type) {
      if (!item) return;
      if (item.new === true) return "table-bold";
    },
    validActions(item) {
      var valid = [];
      for (var i = 0; i < this.actions.length; i++) {
        if (this.actions[i].rule) {
          var rule = this.actions[i].rule;
          var op = rule.toString().substring(0, 1);
          var equalTo = true;
          if (op == "!") {
            equalTo = false;
            rule = rule.substring(1);
          }
          if (item.hasOwnProperty(rule)) {
            var state = item[rule];
            if (
              (state == true && equalTo == true) ||
              (state == false && equalTo == false) ||
              (state && equalTo == true) ||
              (!state && equalTo == false)
            ) {
              valid.push(this.actions[i]);
            }
          } else {
            valid.push(this.actions[i]);
          }
        } else {
          valid.push(this.actions[i]);
        }
      }
      return valid;
    },
    actionClicked(e, sender) {
      console.log("actionClicked", e, sender);
      for (var i = 0; i < this.actions.length; i++) {
        if (this.actions[i].key == e) {
          this.selected = !Array.isArray(sender) ? [sender.item] : sender;

          if (this.actions[i].hasOwnProperty("router")) {
            let route = this.actions[i].router.to;
            if (this.selected) {
              let item = this.selected[0];
              for (var property in item) {
                route = route.replace("%" + property + "%", item[property]);
              }
            }
            this.$router.push(route);
            return;
          }

          if (this.actions[i].hasOwnProperty("action")) {
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            sender.rowSelected = true;
            console.log("sender=", sender);
            this.action = this.actions[i].action;
            this.actionActive = true;
            sender.toggleDetails();
            return;
          }

          if (this.actions[i].hasOwnProperty("modal")) {
            this.modal = this.actions[i].modal;
            this.modalActive = true;
            return;
          }

          if (this.actions[i].hasOwnProperty("component")) {
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            sender.toggleDetails();
            return;
          }
        }
      }
      let payload = {
        endpoint: this.endpoint,
        action: e,
        data: !Array.isArray(sender) ? [sender.item] : sender,
      };
      console.log("payload", payload);
      this.$store.dispatch("dataupdate", payload);
    },
    async discard(item) {
      if (item) {
        item.toggleDetails();
        return;
      }
      return;
    },
  },
};
</script>

<style>
</style>